import { useState, useEffect, useCallback } from 'react';
import { licenseService } from '../services/licenseService';
import { LicenseVerificationState } from '../types/license';

interface UseLicenseVerificationProps {
  apiUrl?: string;
  systemUrl?: string;
  systemToken?: string;
  systemType?: string;
}

export const useLicenseVerification = ({
  apiUrl,
  systemUrl,
  systemToken,
  systemType,
}: UseLicenseVerificationProps): LicenseVerificationState => {
  const [hasLicenseAccess, setHasLicenseAccess] = useState<boolean | null>(null);
  const [isVerifyingLicense, setIsVerifyingLicense] = useState(true);

  const verifyLicense = useCallback(async () => {
    const effectiveSystemUrl = systemUrl || 'http://localhost:8080';
    const effectiveSystemToken = systemToken || 'local-dev-token';

    if (!effectiveSystemUrl || !effectiveSystemToken || !apiUrl) {
      setHasLicenseAccess(false);
      setIsVerifyingLicense(false);
      return;
    }


    try {
      const hasAccess = await licenseService.verifyLicense(apiUrl, effectiveSystemUrl, effectiveSystemToken, systemType);
      setHasLicenseAccess(hasAccess);
    } catch (error) {
      setHasLicenseAccess(false);
    } finally {
      setIsVerifyingLicense(false);
    }
  }, [apiUrl, systemUrl, systemToken, systemType]);

  useEffect(() => {
    verifyLicense();
  }, [verifyLicense]);

  return {
    hasLicenseAccess,
    isVerifyingLicense,
  };
};